import { motion } from "framer-motion";

// Shared framer-motion variants + helpers for GeoNetix

export const easeOutExpo = [0.16, 1, 0.3, 1];

// Smooth scroll to an element/selector (works with Lenis; header offset via CSS scroll-margin-top)
export function scrollToEl(target) {
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: "smooth" });
}

export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: easeOutExpo, delay: i * 0.08 },
  }),
};

export const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
};

// Masked line reveal used across headings
export function MaskLine({ children, delay = 0, className = "", mode = "scroll" }) {
  const anim = { y: "0%" };
  const trans = { duration: 0.9, ease: easeOutExpo, delay };
  const common = {
    className: `block ${className}`,
    initial: { y: "110%" },
    transition: trans,
  };
  return (
    <span className="line-mask">
      {mode === "load" ? (
        <motion.span {...common} animate={anim}>
          {children}
        </motion.span>
      ) : (
        <motion.span
          {...common}
          whileInView={anim}
          viewport={{ once: true, margin: "-8%" }}
        >
          {children}
        </motion.span>
      )}
    </span>
  );
}

export function Reveal({ children, delay = 0, className = "", y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.8, ease: easeOutExpo, delay }}
    >
      {children}
    </motion.div>
  );
}
